import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getFuelStations(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATIONS,
    options
  )
}

function _getFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION,
    options
  )
}

function _getFuelStationPreview(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_PREVIEW,
    options
  )
}
function _getFuelStationPopup(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_POPUP,
    options
  )
}

function _postFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].POST_FUEL_STATION,
    options
  )
}

function _putFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].PUT_FUEL_STATION,
    options
  )
}

function _patchFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].PATCH_FUEL_STATION,
    options
  )
}

function _deleteFuelStation(options = {}) {
  return _apiRequestWrap(
    ModulesMap.FUEL_STATIONS,
    ModulesConfigMap[ModulesMap.FUEL_STATIONS].DELETE_FUEL_STATION,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATIONS]: _getFuelStations,
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION]: _getFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_PREVIEW]: _getFuelStationPreview,
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].GET_FUEL_STATION_POPUP]: _getFuelStationPopup,
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].POST_FUEL_STATION]: _postFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].PUT_FUEL_STATION]: _putFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].PATCH_FUEL_STATION]: _patchFuelStation,
  [ModulesConfigMap[ModulesMap.FUEL_STATIONS].DELETE_FUEL_STATION]: _deleteFuelStation

}